export default "__VITE_ASSET__BNexTK_Q__"